import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {fieldsToDataToSend} from '../../common/functions/convert'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import {validateField} from '../../../actions/helpers/validation'
import {
  fetchSkillVendorEditDataSuccess,
  validateSkillVendorEditField,
  submitSkillVendorEditFields,
  clearSkillVendorEditFields,
  clearSkillVendor} from '../../../actions/pages/skillvendor-page'
import EditForm from '../../../pages/EditForm'
import CheckboxField from '../../common/form/CheckboxField'
import Select from '../../common/form/Select'
import Textarea from '../../../pages/Textarea'
import Alert from '../../../ui-elements/alerts/Alert'
import '../../../css/ui-elements/modals.css'

class SkillVendorEditPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'lg',
      errorMsg: null,
      profileTypes: this.props.skillVendorOverview.ProfileTypes
    }

    this.toggle = this.toggle.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.openPopup = this.openPopup.bind(this)
  }

  openPopup() {
    let id = parseInt(this.props.skillVendorId, 10);

    if (!Number.isInteger(id)){
      return;
    }

    this.toggle();

    let url = 'skillvendors/' + id + '/edit';

    this.props.clearSkillVendorEditFields();
    this.setState({
      errorMsg: null
    })

    this.props.ajax.get(url, true, (data) => {
      //here is bug from skillVendor id 250
        data.DoNotUseReasons.SelectedValue = "Competitor";

      //here should be comment?
      this.props.fetchSkillVendorEditDataSuccess(data);
    });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  submitForm(event) {
    event.preventDefault();

    let validatedFields = this.props.fields.map(field => validateField(field))

    let isValid =
        validatedFields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true


    this.props.submitSkillVendorEditFields(validatedFields);

    if (!isValid){
      return;
    }

    //basic fields to send without profile fields
    let basicFields = [this.props.fields[0], this.props.fields[1], this.props.fields[2], this.props.fields[3], this.props.fields[4]]

    let dataToSend = fieldsToDataToSend(basicFields);

    dataToSend.Profiles = [];

    let doNotUseAdaptor = this.props.fields.find(f => f.name == 'DoNotUseAdaptor').value;
    let doNotUseReasonAdaptor = this.props.fields.find(f => f.name == 'DoNotUseReasonAdaptor').value;
    let doNotUseCommentAdaptor = this.props.fields.find(f => f.name == 'DoNotUseCommentAdaptor').value;

    let doNotUseAdaptorObj = {
      ProfileType: 'Adaptor',
      DoNotUse: doNotUseAdaptor,
      DoNotUseReason: doNotUseAdaptor ? doNotUseReasonAdaptor:null,
      DoNotUseComment: doNotUseAdaptor ? doNotUseCommentAdaptor:null
    }

    let doNotUseDirector = this.props.fields.find(f => f.name == 'DoNotUseDirector').value;
    let doNotUseReasonDirector = this.props.fields.find(f => f.name == 'DoNotUseReasonDirector').value;
    let doNotUseCommentDirector = this.props.fields.find(f => f.name == 'DoNotUseCommentDirector').value;

    let doNotUseDirectorObj = {
      ProfileType: 'Director',
      DoNotUse: doNotUseDirector ,
      DoNotUseReason: doNotUseDirector ? doNotUseReasonDirector:null,
      DoNotUseComment: doNotUseDirector ? doNotUseCommentDirector:null
    }

    let doNotUseTranslator = this.props.fields.find(f => f.name == 'DoNotUseTranslator').value;
    let doNotUseReasonTranslator = this.props.fields.find(f => f.name == 'DoNotUseReasonTranslator').value;
    let doNotUseCommentTranslator = this.props.fields.find(f => f.name == 'DoNotUseCommentTranslator').value;

    let doNotUseTranslatorObj = {
      ProfileType: 'Translator',
      DoNotUse: doNotUseTranslator ,
      DoNotUseReason: doNotUseTranslator ? doNotUseReasonTranslator:null,
      DoNotUseComment: doNotUseTranslator ? doNotUseCommentTranslator:null
    }

    let doNotUseSinger = this.props.fields.find(f => f.name == 'DoNotUseSinger').value;
    let doNotUseReasonSinger = this.props.fields.find(f => f.name == 'DoNotUseReasonSinger').value;
    let doNotUseCommentSinger = this.props.fields.find(f => f.name == 'DoNotUseCommentSinger').value;

    let doNotUseSingerObj = {
      ProfileType: 'Singer',
      DoNotUse: doNotUseSinger ,
      DoNotUseReason: doNotUseSinger ? doNotUseReasonSinger:null,
      DoNotUseComment: doNotUseSinger ? doNotUseCommentSinger:null
    }

    let doNotUseVoiceActor = this.props.fields.find(f => f.name == 'DoNotUseActor').value;
    let doNotUseReasonVoiceActor = this.props.fields.find(f => f.name == 'DoNotUseReasonActor').value;
    let doNotUseCommentVoiceActor = this.props.fields.find(f => f.name == 'DoNotUseCommentActor').value;

    let doNotUseVoiceActorObj = {
      ProfileType: 'VoiceActor',
      DoNotUse: doNotUseVoiceActor,
      DoNotUseReason: doNotUseVoiceActor ? doNotUseReasonVoiceActor:null,
      DoNotUseComment: doNotUseVoiceActor ? doNotUseCommentVoiceActor:null
    }

    let doNotUseLyricist = this.props.fields.find(f => f.name == 'DoNotUseLyricist').value;
    let doNotUseReasonLyricist = this.props.fields.find(f => f.name == 'DoNotUseReasonLyricist').value;
    let doNotUseCommentLyricist = this.props.fields.find(f => f.name == 'DoNotUseCommentLyricist').value;

    let doNotUseLyricistObj = {
      ProfileType: 'Lyricist',
      DoNotUse: doNotUseLyricist,
      DoNotUseReason: doNotUseLyricist ? doNotUseReasonLyricist:null,
      DoNotUseComment: doNotUseLyricist ? doNotUseCommentLyricist:null
    }

    let doNotUseEditor = this.props.fields.find(f => f.name == 'DoNotUseEditor').value;
    let doNotUseReasonEditor = this.props.fields.find(f => f.name == 'DoNotUseReasonEditor').value;
    let doNotUseCommentEditor = this.props.fields.find(f => f.name == 'DoNotUseCommentEditor').value;

    let doNotUseEditorObj = {
      ProfileType: 'Editor',
      DoNotUse: doNotUseEditor,
      DoNotUseReason: doNotUseEditor ? doNotUseReasonEditor:null,
      DoNotUseComment: doNotUseEditor ? doNotUseCommentEditor:null
    }

    let doNotUseSoundEngineer = this.props.fields.find(f => f.name == 'DoNotUseSoundEngineer').value;
    let doNotUseReasonSoundEngineer = this.props.fields.find(f => f.name == 'DoNotUseReasonSoundEngineer').value;
    let doNotUseCommentSoundEngineer = this.props.fields.find(f => f.name == 'DoNotUseCommentSoundEngineer').value;

    let doNotUseSoundEngineerObj = {
      ProfileType: 'SoundEngineer',
      DoNotUse: doNotUseSoundEngineer,
      DoNotUseReason: doNotUseSoundEngineer ? doNotUseReasonSoundEngineer:null,
      DoNotUseComment: doNotUseSoundEngineer ? doNotUseCommentSoundEngineer:null
    }

    this.state.profileTypes.map((profileType) => {
      if(profileType.Key == 'Adaptor'){
        dataToSend.Profiles.push(doNotUseAdaptorObj);
      }
      if(profileType.Key == 'Director'){
        dataToSend.Profiles.push(doNotUseDirectorObj);
      }
      if(profileType.Key == 'Translator'){
        dataToSend.Profiles.push(doNotUseTranslatorObj);
      }
      if(profileType.Key == 'Singer'){
        dataToSend.Profiles.push(doNotUseSingerObj);
      }
      if(profileType.Key == 'VoiceActor'){
        dataToSend.Profiles.push(doNotUseVoiceActorObj);
      }
      if(profileType.Key == 'Lyricist'){
        dataToSend.Profiles.push(doNotUseLyricistObj);
      }
      if(profileType.Key == 'Editor'){
        dataToSend.Profiles.push(doNotUseEditorObj);
      }
      if(profileType.Key == 'SoundEngineer'){
        dataToSend.Profiles.push(doNotUseSoundEngineerObj);
      }
    });

    let url = 'skillvendors/' + this.props.skillVendorId ;

    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response.Status === 'OK') {
          this.toggle();
          this.props.clearSkillVendor();
          this.props.notify(`The talent has been updated.`);
        }
        else{
          this.setState({
            errorMsg: `Can not update talent (id: ${this.props.skillVendorId})`
          })
        }
      })
  }

  render() {
    let fields = this.props.fields;

    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>Edit talent</ModalHeader>
          <ModalBody>
            {this.state.errorMsg &&
              <Alert className="alert alert-danger alert-outline">
                {this.state.errorMsg}
              </Alert>
            }
            <EditForm
              title=""
              description="">
                <div>
                {fields[0] && <CheckboxField field={fields[0]} validate={this.props.validateSkillVendorEditField} />}
                {fields[4] && <Textarea field={fields[4]} validate={this.props.validateSkillVendorEditField} rows="5" />}
                </div>
                <div style={{overflowY : "hidden",overflowX : "auto",whiteSpace: "nowrap", display:"flex"}}>
                  <div className="col-5">
                    <div>Default (applies to new profile) </div><br/>
                    {fields[1] && <CheckboxField field={fields[1]} validate={this.props.validateSkillVendorEditField} />}
                    {fields[2] && <Select field={fields[2]} validate={this.props.validateSkillVendorEditField} />}
                    {fields[3] && <Textarea field={fields[3]} validate={this.props.validateSkillVendorEditField} rows="5" />}
                  </div>




                    {this.state.profileTypes && this.state.profileTypes.map((profileType, i) => {
                      if (profileType.Key == 'Adaptor') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseAdaptor') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseAdaptor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonAdaptor') && <Select field={fields.find(f => f.name === 'DoNotUseReasonAdaptor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentAdaptor') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentAdaptor')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'Director') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseDirector') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseDirector')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonDirector') && <Select field={fields.find(f => f.name === 'DoNotUseReasonDirector')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentDirector') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentDirector')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'Translator') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseTranslator') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseTranslator')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonTranslator') && <Select field={fields.find(f => f.name === 'DoNotUseReasonTranslator')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentTranslator') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentTranslator')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'Singer') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseSinger') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseSinger')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonSinger') && <Select field={fields.find(f => f.name === 'DoNotUseReasonSinger')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentSinger') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentSinger')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'VoiceActor') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseActor') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseActor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonActor') && <Select field={fields.find(f => f.name === 'DoNotUseReasonActor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentActor') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentActor')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'Lyricist') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseLyricist') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseLyricist')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonLyricist') && <Select field={fields.find(f => f.name === 'DoNotUseReasonLyricist')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentLyricist') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentLyricist')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'Editor') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseEditor') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseEditor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonEditor') && <Select field={fields.find(f => f.name === 'DoNotUseReasonEditor')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentEditor') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentEditor')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      if (profileType.Key == 'SoundEngineer') {
                        return (
                          <div className="col-5" key={i}>
                            <div>{profileType.Label}</div><br/>
                            {fields.find(f => f.name === 'DoNotUseSoundEngineer') && <CheckboxField field={fields.find(f => f.name === 'DoNotUseSoundEngineer')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseReasonSoundEngineer') && <Select field={fields.find(f => f.name === 'DoNotUseReasonSoundEngineer')} validate={this.props.validateSkillVendorEditField} />}
                            {fields.find(f => f.name === 'DoNotUseCommentSoundEngineer') && <Textarea field={fields.find(f => f.name === 'DoNotUseCommentSoundEngineer')} validate={this.props.validateSkillVendorEditField} rows="5" />}
                          </div>
                        );
                      }

                      return null;
                    })}

                    </div>


            </EditForm>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" type="submit" onClick={this.submitForm}>Save</button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>Close</button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={this.openPopup}>Edit</button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorOverview: state.skillVendorPage.overview,
  fields: state.skillVendorEdit.fields
})
const mapDispatchToProps = dispatch => ({
  fetchSkillVendorEditDataSuccess: (editData) => dispatch(fetchSkillVendorEditDataSuccess(editData)),
  submitSkillVendorEditFields: fields => dispatch(submitSkillVendorEditFields(fields)),
  validateSkillVendorEditField: (value, field) => dispatch(validateSkillVendorEditField(value, field)),
  clearSkillVendorEditFields: () => dispatch(clearSkillVendorEditFields()),
  clearSkillVendor: () => dispatch(clearSkillVendor())
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(SkillVendorEditPopup)
